export { default } from "./SimpleTable";
